module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "space-20"
  }), _vm._v(" "), _c('img', {
    staticClass: "Loca.Shop",
    attrs: {
      "src": _vm.imageUrl('locashop-loading.gif'),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "space-20"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-adbec9ea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/Loading.vue
// module id = 1031
// module chunks = 34